export default {
    palette: {
        type: [String, Array],
        default: undefined
    }, 
    columns: {
        type: Number,
        default: undefined
    }, 
    tileSize: {
        type: [Number, Object],
        default: undefined
    }, 
    value: {
        type: String,
        default: undefined
    }, 

    // Events
    change: Function
}


// WEBPACK FOOTER //
// ./packages/kendo-inputs-vue-wrapper/src/KendoColorPalette/ColorPaletteProps.js